import { Route } from '@angular/router';
import { AuthGuard } from '@core/auth/auth.guard';
import { initialDepsResolver } from './app.resolvers';
import { Constants } from '@core/constants/constants';

export const appRoutes: Route[] = [

    // pages routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        loadComponent: () => import('app/layout/layout.component').then(m => m.LayoutComponent),
        data: {
            layout: 'dense'
        },
        resolve: {
            initialData: initialDepsResolver
        },
        children: [
            { path: '', loadChildren: () => import('app/pages/pages.routes') },
        ]
    },

    /** external redirect to the Auth app registration page (public, no AuthGuard) */
    {
        path: Constants.registerRoute,
        loadComponent: () => import('app/pages/auth-redirect/register-redirect.component').then(m => m.RegisterRedirectComponent)
    },

    /** wildcard route */
    {
        path: '**',
        redirectTo: Constants.notFoundRoute
    },
    {
        path: Constants.notFoundRoute,
        loadChildren: () => import('app/pages/errors/error-404/error-404.routes')
    }
];
